export async function LoadScene() {
    let token = window.localStorage.getItem('token');
    if (token) {

      // await fetch("https://stg-api.cortishare.com/api/app/WebXR/LoadScene", {
      //       method: 'GET', // or 'PUT'
      //       headers: {
      //         "accept": "*/*",
      //         "X-XSRF-TOKEN": "CfDJ8JJvQWwoN1dFtIXx8cOdPtEYxAJF-164ZNgU7IQpYiPDtSKTR_OJq8rIkZzg2PHA_nOnEaNds6i22F9-nUiimkoEHhObZihUWQtlVmZx0_Ccz_26vZeZdQCUXQRPKqk6cGHPfMJF8Y_IItueiqwNBr0",
      //         "Authorization": "Bearer " + token,
      //         "Content-Type": "application/json-patch+json"
      //       }})
      // .then(response => response.text())
      // .then(result => {
      //   console.log(result)
      //   return result;
      // })
      // .catch(error => console.log('error', error));
      try {
        let res = await fetch('https://stg-api.cortishare.com/api/app/WebXR/LoadScene', {
          method: 'GET', // or 'PUT'
          headers: {
            "accept": "*/*",
            "X-XSRF-TOKEN": "CfDJ8JJvQWwoN1dFtIXx8cOdPtEYxAJF-164ZNgU7IQpYiPDtSKTR_OJq8rIkZzg2PHA_nOnEaNds6i22F9-nUiimkoEHhObZihUWQtlVmZx0_Ccz_26vZeZdQCUXQRPKqk6cGHPfMJF8Y_IItueiqwNBr0",
            "Authorization": "Bearer " + token,
            "Content-Type": "application/json-patch+json"
          },
        });
        console.log(res.status)
        if(res.status == 401){
          console.log("unauthorised");
          const modalButton = document.querySelector(".modal-button");
          const saveButton = document.querySelector(".save-button");
          modalButton.style.display = 'block';
          saveButton.style.display = 'none';
          window.localStorage.removeItem('token');
          return;
        }
        return await res.json();
      } catch (error) {
        console.log(error);
      }
    }
    else {
       return null;
    }
  }